"use strict";
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectorTraceExporter = void 0;
const CollectorExporterBrowserBase_1 = require("./CollectorExporterBrowserBase");
const transform_1 = require("../../transform");
const DEFAULT_SERVICE_NAME = 'collector-trace-exporter';
const DEFAULT_COLLECTOR_URL = 'http://localhost:55681/v1/trace';
/**
 * Collector Trace Exporter for Web
 */
class CollectorTraceExporter extends CollectorExporterBrowserBase_1.CollectorExporterBrowserBase {
    convert(spans) {
        return transform_1.toCollectorExportTraceServiceRequest(spans, this, true);
    }
    getDefaultUrl(config) {
        return config.url || DEFAULT_COLLECTOR_URL;
    }
    getDefaultServiceName(config) {
        return config.serviceName || DEFAULT_SERVICE_NAME;
    }
}
exports.CollectorTraceExporter = CollectorTraceExporter;
//# sourceMappingURL=CollectorTraceExporter.js.map